module.exports = __webpack_public_path__ + "img/printer.730e2d90.svg";